import { getClientCookie } from "@lib/cookies.client";
import { getAckodriveAccessToken } from "@utils/ackodriveTokensCookie";

const getRetailTokenClient = async () => {
  const tokensString = await getClientCookie("ackodrive_tokens");

  return getAckodriveAccessToken(tokensString) || "";
};

export default getRetailTokenClient;
